import { render } from "./OpenHourFormSidebar.vue?vue&type=template&id=09dddb72"
import script from "./OpenHourFormSidebar.vue?vue&type=script&lang=js"
export * from "./OpenHourFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__